export default __webpack_public_path__ + "static/media/physics.7bc06128.svg";